import {SvgIcon} from "@mui/material";

export default function BotIcon(props) {
    return <SvgIcon {...props} viewBox="0 0 100 100">
        <line x1="50" y1="20" x2="50" y2="1" stroke="currentColor" strokeWidth="4"/>
        <rect x="10" y="20" width="80" height="40" rx="20" fill="none" stroke="currentColor" strokeWidth="6" />
        <rect x="10" y="72" width="80" height="15" rx="5" fill="none" stroke="currentColor" strokeWidth="6" />
        <circle cx="35" cy="40" r="5" fill="inherit" />
        <circle cx="65" cy="40" r="5" fill="inherit" />
    </SvgIcon>
}